import { IMasterclassDescription } from '@/interfaces/masterclassDescription';
import useMasterclassDescriptionStore from '@/store/MasterClassDescription/useMasterclasDescriptionStore';
import { Container, Typography } from '@pwskills/rachnaui';
import { companyImage } from '@/utils/common/env.constants';
import { useRouter } from 'next/router';
import { MASTERCLASS_TYPES } from '@/utils/masterclass/masterclass';
import { getSocialUrl } from '@/utils/common/common';

const MentorSection = () => {
  const masterclassDetails = useMasterclassDescriptionStore(
    (state: { masterclassDetails: IMasterclassDescription }) => state.masterclassDetails
  );

  const instructor = masterclassDetails?.instructors?.[0] || {};
  const { instructorDetails } = instructor || [];
  const router = useRouter();
  const { type } = router.query;
  const isDashboard = router.pathname.includes('/dashboard');
  return (
    <div className={`${isDashboard ? '' : 'bg-blue-50'} w-full`}>
      <Container
        id="category-hero-section"
        className={`${
          isDashboard
            ? 'medium:!px-12 !pt-6 !pb-6 medium:!pr-0 px-4 large:!px-12'
            : '!py-6 medium:!p-8 large:!py-14 !px-4 large:!px-20'
        } flex flex-col`}
      >
        <div className="flex flex-col gap-6 medium:gap-4 large:gap-[56px]">
          <Typography
            component={isDashboard ? 'subheading' : 'h4'}
            variant="bold"
            className={`${
              isDashboard
                ? 'text-left'
                : 'text-center !text-[24px]  !leading-[36px] medium:!text-[32px] medium:!leading-[40px] large!text-[40px] large:!leading-[50px]'
            }`}
          >
            Meet Your Mentor
          </Typography>

          <div className="flex flex-col-reverse medium:flex-row gap-6 medium:justify-between items-center ">
            <div className="flex flex-col gap-6 medium:!gap-3 medium:w-[297px] large:w-[408px]">
              <div className="flex items-center medium:!items-start  flex-col gap-1">
                <Typography
                  component={isDashboard ? 'subheading' : 'h4'}
                  variant="bold"
                  className={`${isDashboard ? 'text-[20px]' : '!text-[20px] !leading-[30px]'}`}
                >
                  {instructor?.name}
                </Typography>
                <Typography
                  component="body-regular"
                  variant="regular"
                  className={`${
                    isDashboard
                      ? 'text-[16px] text-gray-700'
                      : '!text-[16px] !leading-[24px] text-gray-850'
                  }`}
                >
                  {instructorDetails?.designation}
                </Typography>
              </div>
              {instructorDetails?.pastCompanies && (
                <div className="flex justify-center medium:!justify-start items-center medium:!items-start gap-[20px]">
                  {instructorDetails?.pastCompanies?.map((company) => {
                    return (
                      <div className="p-[2px]" key={company._id}>
                        <img
                          src={`${companyImage}/company_logos/${company.companyLogoFileName}`}
                          alt="company"
                          className="w-auto h-[24px]"
                        />
                      </div>
                    );
                  })}
                </div>
              )}
              <Typography
                component="subheading"
                variant="regular"
                className={`${
                  isDashboard
                    ? 'text-[18px] text-gray-700'
                    : 'small:!text-[14px] small:!leading-[22px] medium:!text-[18px] text-center medium:!text-left  medium:!leading-[26px] text-gray-850'
                }`}
              >
                {instructor?.description}
              </Typography>
              {type !== MASTERCLASS_TYPES.MARKETING &&
                getSocialUrl(instructor?.social?.linkedin) && (
                  <button
                    type="button"
                    className="border border-linkBlue w-full  medium:!w-fit rounded"
                    onClick={() => {
                      window.open(getSocialUrl(instructor?.social?.linkedin), '_new');
                    }}
                  >
                    <div className="flex py-[14px] px-4 gap-2 justify-center items-center">
                      <Typography
                        component="body-regular"
                        variant="bold"
                        className="!text-[16px] !leading-[24px] text-linkBlue"
                      >
                        Connect On LinkedIn
                      </Typography>
                      <img src="/images/masterclassDescription/linkedin.svg" alt="linkedIn" />
                    </div>
                  </button>
                )}
            </div>
            <div className="bg-white rounded-lg shadow-medium p-5 relative h-fit w-full medium:!w-fit">
              <img
                src="/images/masterclassDescription/mentor_ribbon.svg"
                alt="mentorImage"
                className="absolute top-[-12px] medium:top-[-11px] right-[-12px] medium:right-[-34px] z-[2]"
              />

              <div className="bg-yellow-50 rounded-lg relative w-full medium:!w-[280px] h-[336px]">
                <img
                  src="/images/masterclassDescription/mentor_bg_web.png"
                  alt="mentorBg"
                  className="absolute right-0 bottom-0"
                />
                {/* <img
                  src={instructor?.img?.link}
                  alt="mentorImage"
                  className=" relative z-[1] mx-auto"
                /> */}

                <div
                  style={{
                    backgroundImage: `url(${instructor?.img?.link})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                  }}
                  className="w-full h-full rounded-lg z-[1] relative"
                />
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default MentorSection;
